// extracted by mini-css-extract-plugin
export default {"div":"PageChange_div__SLi7u","up":"PageChange_up__w2daV"};